<div class="block-wrapper">
    <div class="container" *ngFor="let container of containers; let i = index">
        <container-with-items *ngIf="container.items.length > 0" [container]="container" [index]="i + 1" (expandContainer)="onExpandContainer($event)" [type]="'Events'"></container-with-items>
    </div>
</div>